import { Door } from './../models/door.model';
import { environment } from './../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class DoorService {
  /**
   * Build the component and initialize certain attributes.
   * @param {HttpClient} http Service to make API calls.
   */
  constructor(private http: HttpClient) { }

  /**
   * Sends a door to store it in the backend.
   */
  create(door: Door) {
    return this.http.post(`${environment.apiUrl}/doors`, door);
  }
  /**
   * Updates a door in the backend.
   * @param {string} id Door ID.
   * @param {Door} data Door to be updated.
   */
  update(id: string, door: Door) {
    return this.http.put(`${environment.apiUrl}/doors/${id}`, door);
  }
  /**
   * Deletes a door in the backend.
   * @param {string} id Door ID.
   */
  delete(id: string) {
    return this.http.delete(`${environment.apiUrl}/doors/${id}`);
  }
  /**
   * Gets one door from the backend.
   * @param {string} id Door ID.
   */
  show(id: string) {
    return this.http.get(`${environment.apiUrl}/doors/${id}`);
  }
  /**
   * Gets Nodes filtering by certain parameters.
   * @param params Parameters to filter the query.
   */
  showAll(params: any = {}) {
    return this.http.get(`${environment.apiUrl}/doors`, { params: params });
  }
  unlock(door: Door, credentials: any = {}) {
    return this.http.post(`${environment.apiUrl}/doors/unlock`,
      {
        door: door,
        credentials: credentials
      });
  }
}
